module.exports = __webpack_public_path__ + "pc/img/body_basic 8.bd559a3b.jpg";